export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            了解妖精漫画网的故事与使命
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200 p-8 md:p-12">
            <div className="max-w-2xl mx-auto text-center">
              <div className="w-20 h-20 mx-auto flex items-center justify-center bg-primary-500 rounded-2xl mb-6">
                <i className="ri-book-open-line text-4xl text-background-50"></i>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                妖精漫画网成立于2020年，由一群热爱漫画的开发者创立。我们致力于打造最优质的<strong>免费漫画</strong>在线阅读平台，让每一位漫画爱好者都能轻松找到心仪的<strong>韩漫</strong>、<strong>日漫</strong>和<strong>国漫</strong>作品。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                经过多年发展，妖精漫画网已收录超过<strong>10万部漫画作品</strong>，涵盖恋爱、热血、奇幻、悬疑、搞笑等全类型<strong>漫画大全</strong>。我们坚持<strong>漫画全集</strong>免费在线观看的原则，配合下拉式流畅阅读技术，为800万+活跃读者提供极致的阅读体验。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                未来，妖精漫画网将继续拓展漫画资源，优化阅读体验，用心服务每一位漫画爱好者。无论你是新读者还是老漫迷，这里都有属于你的精彩漫画世界。好看的漫画，尽在妖精漫画。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}